export default __webpack_public_path__ + "static/media/5528.ff31e763.png";